/** @module SiteAdmin/Locale/TimeExampleRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/Renderer",
	"./util"
], function(declare,Renderer,util) {

	return declare(Renderer, {

		/**
		 * Format the time against the particular pattern
		 */
		toValue: function(ctx, h) {
			var locale = ctx.getNode();
			var pattern =  util.getLocaleSettings(ctx).TimePattern;

			var result = util.getDateTimeFormatBasedOnLocale(locale, "time", pattern);
			return result;
		}
	});
});